<template>
  <div class="complete-wrap">
    <div class="content">
      <svg width="48" height="48" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="48" cy="48" r="48" fill="#0AC76F" />
        <path
          d="M71.5087 31.625L76.912 37.1537L46.0406 68.5976C44.5899 70.0819 42.263 70.1231 40.7637 68.7213L40.6373 68.5976L20.4414 48.0077L25.8447 42.479L43.3384 60.304L71.5087 31.625Z"
          fill="white"
        />
      </svg>
      <div class="info">实名认证申请已提交</div>
      <div class="sub-info">请等待医生审核</div>

      <div class="btns">
        <van-button type="primary" block @click="handleOther">继续新增申请</van-button>
        <van-button class="van-button--info" block @click="goHome">返回首页</van-button>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { router } from '@/router';

const handleOther = () => {
  router.push({ name: 'manual-records', params: { clear: '1' } });
};
const goHome = () => {
  router.push({ path: '/' });
};
</script>
<style lang="less" scoped>
.complete-wrap {
  display: flex;
  flex-direction: column;
  padding-top: 150px;
  height: 100%;
  min-height: calc(100vh - 160px);
  background: #fff;

  .content {
    margin-top: 100px;
    text-align: center;

    .info {
      margin-top: 32px;
      line-height: 52px;
      font-weight: 500;
      font-size: 34px;
      letter-spacing: 2px;
    }

    .sub-info {
      margin-top: 38px;
      line-height: 48px;
      font-weight: 400;
      font-size: 32px;
      letter-spacing: 2px;
    }

    .btns {
      margin-top: 100px;
    }

    .van-button {
      margin: auto;
      margin-top: 36px;
      width: 310px;
      height: 80px;
      font-size: 34px;
    }
  }
}
</style>
